module.exports = __webpack_public_path__ + "static/cio-jeb-bentley.808dd2cb.webp";